export const fi = {
  "claimListingPage": {
    "title": "Julkaise myyntikohde",
    "descriptionPrefix": "Sinut on kutsuttu vahvistamaan tämä ennakkoon valmisteltu ilmoitus. ",
    "descriptionLoggedIn": " Paina \"Vahvista & julkaise\" vahvistaaksesi ilmoituksen. Julkaisun jälkeen voit halutessasi muokata ilmoitusta.",
    "descriptionLoggedOut": " Kirjaudu sisään tai luo tunnus julkaistaksesi ilmoituksen. Julkaisun jälkeen voit halutessasi muokata ilmoitusta.",
    "intendedFor": "Tämä ilmoitus on lähetetty:",
    "loggedInAs": "Olet kirjautunut käyttäjänä {{email}}. Voit silti vahvistaa tämän ilmoituksen.",
    "existingListingInBuilding": "Sinulla on jo ilmoitus tässä rakennuksessa, joten tätä kutsua ei voi vahvistaa.",
    "loading": "Ladataan ilmoitusta...",
    "notAvailable": {
      "title": "Ilmoitus ei saatavilla",
      "invalidToken": "Tämä vahvistuslinkki on virheellinen tai vanhentunut.",
      "alreadyClaimed": "Tämä ilmoitus on jo vahvistettu.",
      "errorDefault": "Ilmoituksen lataus epäonnistui",
      "homeButton": "Palaa etusivulle"
    },
    "success": {
      "title": "Ilmoitus vahvistettu!",
      "published": "Ilmoituksesi on julkaistu ja näkyy nyt muille käyttäjille.",
      "redirecting": "Siirrytään ilmoitukseen..."
    },
    "action": {
      "readyTitle": "Valmis vahvistamaan ilmoituksen?",
      "readyText": "Vahvistamalla ilmoituksen se julkaistaan tunnuksellesi ja näkyy muille käyttäjille.",
      "claimButton": "Vahvista & julkaise",
      "claiming": "Vahvistetaan..."
    },
    "auth": {
      "ctaTitle": "Kirjaudu tai luo tunnus julkaistaksesi ilmoituksen",
      "ctaText": "Luo maksuton tunnus julkaistaksesi ilmoituksen ja aloittaaksesi yhteydenpidon ostajien kanssa. Pelkkä sähköpostiosoite riittää.",
      "button": "Kirjaudu / Luo tunnus",
      "alreadyHaveAccount": "Onko sinulla jo tunnus? Kirjaudu ja julkaise ilmoitus."
    },
    "expiry": {
      "warning": "Tämä linkki vanhenee {{date}}"
    },
    "details": {
      "title": "Asunnon tiedot",
      "description": "Kuvaus:",
      "size": "Koko:",
      "rooms": "Huoneet:",
      "floor": "Kerros:",
      "condition": "Kunto:",
      "m2": "m²"
    },
    "condition": {
      "recently_renovated": "Äskettäin remontoitu",
      "good_condition": "Hyvä",
      "needs_renovation": "Remontin tarpeessa"
    },
    "amenities": {
      "elevator": "Hissi",
      "balcony": "Parveke"
    },
    "photos": {
      "title": "Asuntokuvat"
    },
    "type": {
      "forSale": "Myynnissä",
      "lookingToBuy": "Ostokiinnostus"
    }
  },
  "landingPage": {
    "startSearch": "Etsi asuntoja",
    "startSearchDesktop": "Etsi asuntoja",
    "latestListings": "Uusimmat kohteet",
    "map": {
      "title": "Asuntokartta"
    },
    "couldBuyOrCouldSellModal": {
      "sell": {
        "title": "Voisin myydä",
        "description": "Syötä kohteen osoite, niin yhdistämme sinut mahdollisiin ostajiin. Käyttö on maksutonta eikä sido mihinkään."
      },
      "buy": {
        "title": "Voisin ostaa",
        "description": "Syötä kohteen osoite, niin yhdistämme sinut myyjiin. Käyttö on maksutonta eikä sido mihinkään."
      },
      "submitError": "Virhe lähetettäessä. Yritä uudelleen.",
      "addressMismatch": "Rakennuksen osoite ei vastaa syötettyä osoitetta. Tarkista osoite tai valitse eri rakennus. Rakennuksen reunalla klikkaamminen saattaa joskus valita naapurirakennuksen osoitteen."
    }
  },
  "newLandingPage": {
    "header": {
      "languageEnglish": "English",
      "languageFinnish": "Suomeksi",
      "switchLanguageToEnglish": "Vaihda kieli englanniksi",
      "switchLanguageToFinnish": "Vaihda kieli suomeksi",
      "signIn": "Kirjaudu",
      "openMenuAria": "Avaa valikko",
      "openProfileAria": "Avaa profiili"
    },
    "menu": {
      "title": "Lisää",
      "closeAria": "Sulje valikko"
    },
    "profile": {
      "title": "Minä",
      "backAria": "Takaisin",
      "closeAria": "Sulje"
    },
    "nav": {
      "label": "Päävalikko",
      "explore": "Tutustu",
      "activity": "Tapahtumat",
      "messages": "Viestit",
      "tools": "Työkalut",
      "unread": "{{label}}, {{count}} lukematonta"
    },
    "activityToast": {
      "found_one": "Löysimme <1>{{count}} kodin</1>, joka voisi kiinnostaa sinua.",
      "found_other": "Löysimme <1>{{count}} kotia</1>, jotka voisivat kiinnostaa sinua.",
      "empty": "Näytämme täällä sinua kiinnostavia koteja."
    },
    "tools": {
      "title": "Jaakko-työkalut",
      "closeAria": "Sulje työkalut",
      "estimate": {
        "title": "Hinta-arvio",
        "subtitle": "Luo kodillesi suuntaa-antava, markkinatietoihin pohjautuva hinta-arvio tekoälyn avulla.",
        "tag": "3 ilmaista arviota päivässä"
      },
      "style": {
        "title": "Myyntikuvien siistiminen",
        "subtitle": "Luo houkuttelevammat myyntikuvat sekunneissa ilmoitusta jättäessäsi.",
        "tag": "60 siistittyä kuvaa ilmaiseksi"
      },
      "boost": {
        "title": "Näkyvyyden tehostus",
        "subtitle": "Mainosta kohdettasi sosiaalisessa mediassa tavoittaaksesi lisää potentiaalisia ostajia.",
        "tag": "49,90 € / 2 viikkoa"
      }
    },
    "toolFlows": {
      "loading": "Ladataan ilmoituksiasi…",
      "error": "Ilmoitusten lataus epäonnistui.",
      "retry": "Yritä uudelleen",
      "empty": {
        "text": "Sinulla ei ole vielä myynti-ilmoitusta. Luo ensin ilmoitus — se vie vain hetken.",
        "cta": "Lisää kotini"
      },
      "pickerHint": "Valitse ilmoitus",
      "boostSuccess": "Pyyntö lähetetty! Saat 12 tunnin sisällä sähköpostin, jossa on lisätiedot ja maksulinkki.",
      "done": "Valmis",
      "start": "Aloita arvio",
      "starting": "Aloitetaan…",
      "startError": "Arvion aloitus epäonnistui. Yritä uudelleen.",
      "dailyLimit": "Päivän arviot on käytetty. Yritä huomenna uudelleen.",
      "rooms": "{{rooms}} huonetta",
      "chooseNewAddress": "Arvioi uusi osoite",
      "chooseFromListings": "Valitse ilmoituksistasi",
      "estimateCtaGet": "Arvioi hinta",
      "addDetailsHint": "Saat tarkemman hinta-arvion.",
      "formTitle": "Hienoa, valmis arvioon?",
      "sellPromptTitle": "Arviointi aloitettu. Laitetaanko koti samalla myyntiin?",
      "sellPromptYes": "Kyllä, laita myyntiin",
      "sellPromptNo": "Ehkä myöhemmin"
    },
    "activity": {
      "title": "Tapahtumat",
      "sections": {
        "myPlaces": "Omat kohteet",
        "buyingInterests": "Ostokiinnostukseni",
        "following": "Seuratut"
      },
      "newBuyers": "{{count}} uutta ostajaa",
      "newListings_one": "{{count}} uusi kohde",
      "newListings_other": "{{count}} uutta kohdetta",
      "newLikes": "{{count}} uutta tykkäystä",
      "buyers": "{{count}} ostajaa",
      "buyersInBuilding_one": "{{count}} ostaja tässä talossa",
      "buyersInBuilding_other": "{{count}} ostajaa tässä talossa",
      "listings_one": "{{count}} kohde",
      "listings_other": "{{count}} kohdetta",
      "confirmedMatches_one": "{{count}} sopiva kohde",
      "confirmedMatches_other": "{{count}} sopivaa kohdetta",
      "possibleMatches_one": "{{count}} mahdollinen kohde",
      "possibleMatches_other": "{{count}} mahdollista kohdetta",
      "floorUnconfirmed": "Kerros ei ole vahvistettavissa",
      "loadMore": "Näytä lisää kohteita",
      "retry": "Yritä uudelleen",
      "likes_one": "{{count}} tykkäys",
      "likes_other": "{{count}} tykkäystä",
      "followingUnnamed": "Seurattu rakennus",
      "promo": {
        "myPlaces": {
          "text": "Lisää ensimmäinen kohteesi ja näe, ketkä voisivat ostaa sen."
        },
        "buyingInterests": {
          "text": "Kerro mitä etsit ja saat ilmoituksia sopivista kohteista."
        },
        "following": {
          "text": "Napauta rakennuksen Ilmoitukset-painiketta seurataksesi sen tapahtumia.",
          "cta": "Selaa karttaa"
        },
        "learnMore": "Lue lisää"
      },
      "detail": {
        "back": "Takaisin tapahtumiin",
        "boost": {
          "title": "Näy useammalle",
          "bodySell": "Tavoittaaksesi vielä enemmän potentiaalisia ostajia voit mainostaa ilmoitustasi kohdennetusti sosiaalisessa mediassa.",
          "bodyBuy": "Tavoittaaksesi vielä enemmän potentiaalisia myyjiä voit mainostaa ilmoitustasi kohdennetusti sosiaalisessa mediassa.",
          "cta": "Mainosta ilmoitustasi",
          "dismiss": "Sulje"
        },
        "newListings": "Uudet kohteet",
        "newBuyers": "Uudet ostajat",
        "otherListings": "Muut kohteet",
        "otherBuyers": "Muut ostajat",
        "possibleTitle": "Mahdolliset kohteet",
        "possibleDescription": "Nämä kohteet voivat sopia toiveisiisi. Joitakin tietoja puuttuu vielä - voit kysyä lisää suoraan myyjältä.",
        "empty": "Ei vielä näytettävää."
      },
      "fab": {
        "openAria": "Luo uusi ilmoitus tai ostokiinnostus",
        "closeAria": "Sulje luontivalikko",
        "couldSell": "Lisää kotisi",
        "interestInBuying": "Kerro myyjille"
      }
    },
    "hero": {
      "homes": "Koteja",
      "and": "ja",
      "buyers": "ostajia",
      "tail": ", joita et löydä muualta.",
      "subheadline": "Puhu suoraan myyjien ja ostajien kanssa – ilman välikäsiä ja välityspalkkioita.",
      "startExploring": "Aloita selaaminen"
    },
    "mapOnboarding": {
      "farTitle": "Avaa mikä tahansa rakennus",
      "farBody": "Zoomaa karttaa ja klikkaa mitä tahansa rakennusta – vaikka siellä ei olisi mitään myynnissä.",
      "farBodyTouch": "Zoomaa karttaa ja napauta mitä tahansa rakennusta – vaikka siellä ei olisi mitään myynnissä.",
      "nearTitle": "Klikkaa mitä tahansa rakennusta",
      "nearTitleTouch": "Napauta mitä tahansa rakennusta",
      "nearBody": "Tutustu rakennukseen, vaikka kukaan ei vielä ostaisi tai myisi siellä.",
      "zoomIn": "Zoomaa",
      "gotIt": "Selvä",
      "dismiss": "Sulje vinkki"
    },
    "explore": {
      "actions": {
        "sellAdvice": "Ilman sitoumuksia ja välityspalkkiota",
        "buyAdvice": "Etsitkö uutta kotia?"
      },
      "search": "Haku",
      "filter": "Suodata",
      "searchAria": "Haku",
      "filterAria": "Suodata",
      "closeSearchAria": "Sulje haku",
      "clearSearchAria": "Tyhjennä haku",
      "geolocateAria": "Näytä sijaintini",
      "closeListAria": "Sulje listaus",
      "testHomeValue": "Testaa kotisi arvo",
      "buyingInterest": "Kerro myyjille",
      "buyingInterestHint": "Etsitkö uutta kotia?",
      "areaInterest": {
        "stage1": "Ostokiinnostusta alueella! Zoomaa taloihin nähdäksesi lisää.",
        "stage2": "Kasvavaa ostokiinnostusta alueella! Zoomaa taloihin nähdäksesi lisää.",
        "stage3": "Vahvaa ostokiinnostusta alueella! Zoomaa taloihin nähdäksesi lisää.",
        "stage4": "Erittäin vahvaa ostokiinnostusta alueella! Zoomaa taloihin nähdäksesi lisää.",
        "stage5": "Poikkeuksellisen vahvaa ostokiinnostusta alueella! Zoomaa taloihin nähdäksesi lisää."
      },
      "sellersCount_one": "{{count}} myyjä",
      "sellersCount_other": "{{count}} myyjää",
      "buyersCount_one": "{{count}} ostaja",
      "buyersCount_other": "{{count}} ostajaa",
      "sellersBuyersAria": "Näytä alueen myyjät ja ostajat",
      "collapsePanelAria": "Pienennä listapaneeli",
      "expandPanelAria": "Laajenna listapaneeli",
      "testHomeValueSubtitle": "ilmaisella Jaakko-arviolla",
      "zoomInAria": "Lähennä",
      "zoomOutAria": "Loitonna",
      "zoomInToSeeAll": "Zoomaa lähemmäs nähdäksesi kaikki kohteet",
      "areaFallback": "Tämä alue",
      "suggestedDistricts": "Ehdotetut kaupunginosat",
      "showcaseCaption": "Katso miten Jaakko toimii käytännössä",
      "showcaseCity": "Helsinki ({{total}} kohdetta)",
      "districtsNearYou": "Kaupunginosat lähelläsi",
      "usingYourLocation": "Käytetään sijaintiasi",
      "youAreHere": "Olet täällä",
      "kmAway": "{{km}} km päässä",
      "loadingDistricts": "Etsitään kaupunginosia…",
      "locationDenied": "Sijainti on estetty tältä sivustolta. Salli se selaimen sivustoasetuksista ja napauta uudelleen.",
      "locationUnavailable": "Sijaintia ei saatu. Tarkista, että paikannus on päällä, ja napauta uudelleen.",
      "locationInsecure": "Sijainti toimii vain suojatussa (https) yhteydessä.",
      "continents": {
        "europe": "Eurooppa",
        "northAmerica": "Pohjois-Amerikka",
        "southAmerica": "Etelä-Amerikka",
        "asia": "Aasia",
        "oceania": "Oseania",
        "world": "Maailma"
      }
    },
    "addMyPlace": {
      "title": "Lisää kotisi",
      "backAria": "Takaisin",
      "closeAria": "Sulje",
      "address": {
        "question": "Mikä on kotisi osoite?",
        "label": "Osoite",
        "placeholder": "Syötä osoite",
        "useCurrentLocation": "Käytä nykyistä sijaintia",
        "locating": "Etsitään sijaintiasi…",
        "locationDenied": "Sijainnin käyttö estettiin. Syötä osoite itse.",
        "locationUnavailable": "Emme löytäneet sijaintiasi. Syötä osoite itse.",
        "houseNumberRequired": "Lisää osoitteeseen talon numero.",
        "addressNotFound": "Emme löytäneet tätä osoitetta. Tarkista talon numero.",
        "noBuildingHere": "Hups – emme löydä tämän osoitteen rakennusta vielä.",
        "checkingBuilding": "Tarkistetaan osoitetta…",
        "loading": "Ladataan…"
      },
      "building": {
        "calloutTitle": "Kotini",
        "notYourBuilding": "Eikö tämä ole rakennuksesi? Valitse oikea klikkaamalla kartalta.",
        "selectBuildingOnMap": "Valitse oikea rakennus klikkaamalla kartalta.",
        "pickNoAddress": "Tälle rakennukselle ei löytynyt osoitetta. Klikkaa toista rakennusta.",
        "buildingLabel": "Rakennus",
        "typeApartment": "Kerrostalo",
        "typeRowHouse": "Rivitalo",
        "typeDuplex": "Paritalo",
        "typeDetached": "Omakotitalo",
        "typeOther": "Muu",
        "next": "Seuraava"
      },
      "size": {
        "question": "Kuinka suuri koti on (m²)?",
        "label": "Koko (m²)",
        "placeholder": "Syötä m²"
      },
      "rooms": {
        "question": "Kuinka monta huonetta kodissa on?",
        "label": "Huoneet",
        "more": "Lisää"
      },
      "publish": {
        "title": "Hienoa, oletko valmis julkaisemaan?",
        "roomsValue": "{{rooms}}h",
        "estimatingPrice": "Automaattinen hinta-arvio",
        "estimateInfoAria": "Tietoa arviosta",
        "estimateInfo": "Jaakko arvioi hinnan tekoälyn ja markkinatietojen avulla. Kyseessä ei ole virallinen arviolausunto, vaan suuntaa-antava keskustelunavaus – voit aina päättää ja asettaa oman hintasi.",
        "addMoreDetails": "Lisää tietoja ja kuvia",
        "addMoreDetailsHint": "Tarkenna hinta-arviota ja tee ilmoituksestasi kiinnostavampi ostajille.",
        "closeDetails": "Sulje tiedot",
        "estimateReadyStrong": "Saat viestin hinta-arviosta noin 15 minuutin kuluessa julkaisusta.",
        "estimateReadyRest": "Voit muokata hintaa milloin tahansa.",
        "publish": "Julkaise kartalle",
        "publishing": "Odota hetki"
      },
      "details": {
        "listingStrength": "Ilmoituksen vahvuus",
        "basic": "Perus",
        "strengthHint": "Lisää kuvia, niin kotisi herättää enemmän kiinnostusta selaajien keskuudessa.",
        "addPhotos": "Lisää kuvia",
        "listingDetails": "Ilmoituksen tiedot",
        "addPhoto": "Lisää kuva",
        "openPhoto": "Avaa kuva {{number}}",
        "photoAlt": "Ilmoituksen kuva {{number}}",
        "photoUploading": "Ladataan...",
        "photoEnhancing": "Parannellaan...",
        "photoTipStrong": "Eikö sinulla ole hyviä kuvia?",
        "photoTipRest": "Lisää kuvat sellaisina kuin ne ovat. Jaakko siistii ja viimeistelee ne hetkessä. Voit aina käyttää myös alkuperäisiä.",
        "enhancedPhotoTipStrong": "Katso parannellut kuvat!",
        "enhancedPhotoTipRest": "Avaa kuva ja vaihda paranneltuun versioon nähdäksesi ja käyttääksesi sitä.",
        "addDescription": "Lisää kuvaus",
        "address": "Osoite",
        "type": "Tyyppi",
        "price": "Hinta (€)",
        "pricePlaceholder": "Syötä hinta (väh. 1 000 €)",
        "priceTipStrong": "Onko sinulla jo hinta tiedossa?",
        "priceTipRest": "Lisää hinta yllä, tai vaihda se milloin tahansa.",
        "priceEstimateTipStrong": "Aseta oma hinta tai anna Jaakon arvioida",
        "priceEstimateTipRest": "Jos jätät kentän tyhjäksi, Jaakko laskee suuntaa-antavan arvion tekoälyn ja markkinatiedon avulla. Voit muokata hintaa milloin vain.",
        "priceTooLow": "Vähimmäishinta on 1 000 €. Poista hinta, niin Jaakko arvioi sen puolestasi.",
        "estimatingTipStrong": "Jaakko arvioi hintaa...",
        "estimatingTipRest": "Arvio valmistuu noin 15 minuutissa. Saat viestin, kun se on valmis. Voit edelleen syöttää oman hintasi.",
        "addFloor": "Lisää kerros",
        "addRenovation": "Lisää remonttitilanne",
        "hasElevator": "Hissi",
        "hasBalcony": "Parveke / terassi",
        "descriptionLabel": "Kuvaus",
        "descriptionPlaceholder": "Kuvaile kotisi parhaita puolia...",
        "floorLabel": "Kerros",
        "floorPlaceholder": "esim. 4",
        "renovationLabel": "Remonttitilanne",
        "renovationSelect": "Valitse remonttitilanne",
        "renovationRecentlyRenovated": "Äskettäin remontoitu",
        "renovationGoodCondition": "Hyvä kunto",
        "renovationNeedsRenovation": "Remontoitava",
        "elevatorLabel": "Hissi",
        "balconyLabel": "Parveke / terassi",
        "optionYes": "Kyllä",
        "optionNo": "Ei"
      },
      "login": {
        "title": "Kirjaudu tai luo tili",
        "google": "Jatka Googlella",
        "facebook": "Jatka Facebookilla",
        "orEmail": "tai jatka sähköpostilla",
        "emailPlaceholder": "Sähköposti",
        "continue": "Jatka",
        "termsPrefix": "Rekisteröitymällä luot Jaakko-tilin ja sitoudut noudattamaan",
        "termsService": "käyttöehtoja",
        "termsMiddle": ", ja vahvistat lukeneesi ja hyväksyväsi Jaakkocom Oy:n",
        "termsPrivacy": "tietosuojakäytäntöä",
        "termsSuffix": "."
      },
      "result": {
        "newBadge": "Uusi",
        "buyers_one": "{{count}} ostaja",
        "buyers_other": "{{count}} ostajaa",
        "followers_one": "{{count}} seuraaja",
        "followers_other": "{{count}} seuraajaa",
        "likeAria": "Tallenna suosikkeihin",
        "closeAria": "Sulje"
      },
      "share": {
        "title": "Kotisi on julkaistu!",
        "subtitle": "Ilmoitamme kohteestasi sopiville ostajille. Saat viestin, kun ostaja ottaa sinuun yhteyttä – voit myös ehdottaa kotiasi ostajille itse, tai jakaa ilmoituksen saadaksesi sille lisää näkyvyyttä.",
        "matchSubtitle": "Ostajat odottavat jo. Näet heidät Tapahtumat-osiossa ja voit ehdottaa kotiasi heille, tai jaa kohteesi saadaksesi vielä lisää näkyvyyttä.",
        "edit": "Muokkaa",
        "shareButton": "Jaa nyt",
        "boostButton": "Mainosta – 49,90 €",
        "boostSubtitle": "Saat lisää ostajia kohdennetuilla mainoksilla.",
        "skipButton": "Ehkä myöhemmin"
      }
    },
    "couldBuy": {
      "boostPromo": {
        "title": "Nopeuta unelmakotisi löytymistä",
        "body": "Mainostamme ostokiinnostustasi alueen asukkaille sosiaalisessa mediassa.",
        "cta": "Tehosta näkyvyyttä"
      },
      "title": "Luo ostokiinnostus",
      "editTitle": "Muokkaa ostokiinnostusta",
      "titlePublished": "Ostokiinnostus julkaistu",
      "titleUpdated": "Ostokiinnostus päivitetty",
      "tooManyAreas": "Voit valita enintään 50 aluetta. Poista osa ja yritä uudelleen.",
      "location": {
        "question": "Mistä voisit ostaa?",
        "hint": "Kiinnostaako lähellä kohdetta {{building}}? Lisää alueita, joita harkitsisit.",
        "placeholder": "Hae kaupunginosaa",
        "searching": "Haetaan…",
        "clearAria": "Tyhjennä",
        "removeChipAria": "Poista alue",
        "radiusLabel": "Tai säde tämän kodin ympärillä",
        "radiusValue": "{{km}} km",
        "radiusOff": "Pois",
        "selectAreaError": "Lisää vähintään yksi alue tai aseta säde."
      },
      "criteria": {
        "question": "Mitä etsit?",
        "sizeLabel": "Vähimmäiskoko (m²)",
        "roomsLabel": "Vähintään huoneita",
        "priceMinLabel": "Vähimmäishinta (€)",
        "priceMaxLabel": "Enimmäishinta (€)",
        "anyPlaceholder": "Mikä tahansa",
        "priceMinHandleAria": "Vähimmäishinta",
        "priceMaxHandleAria": "Enimmäishinta"
      },
      "success": {
        "title": "Valmista tuli!",
        "subtitle": "Ilmoitamme, kun alueillesi ilmestyy sopiva koti.",
        "areasLabel": "Alueesi",
        "radiusArea": "{{km}} km säde",
        "notifyEmail": "Lähetä minulle sähköposteja",
        "notifySms": "Lähetä minulle tekstiviestejä",
        "share": "Jaa kiinnostukseni",
        "done": "Valmis",
        "viewMatches": "Katso sopivat kohteet",
        "matchedSellersOne": "Tässä talossa on jo yksi myyjä, jonka koti vastaa toiveitasi. Avaa ilmoitus ja aloita keskustelu.",
        "matchedSellersOther": "Tässä talossa on jo {{count}} myyjää, joiden kodit vastaavat toiveitasi. Avaa ilmoitus ja aloita keskustelu.",
        "headline": "Hienoa! Ostokiinnostuksesi on nyt aktiivinen.",
        "editHeadline": "Ostokiinnostuksesi on päivitetty.",
        "subtitlePrefix": "Kiinnostuksesi perusteella alamme näyttää sinulle sopivia koteja kohdassa",
        "editSubtitlePrefix": "Näytämme sinulle jatkossakin sopivia koteja kohdassa",
        "subtitleActivity": "Aktiviteetit",
        "notifyHeading": "Ilmoita minulle uusista kohteista",
        "smsNeedsPhone": "Lisää ja vahvista puhelinnumero profiilisi asetuksissa, jotta saat tekstiviestejä.",
        "circleArea": "500 m säde",
        "anyCriteria": "Kaikki kohteet",
        "roomsUnit": "huonetta"
      },
      "share": {
        "title": "Levitä sanaa",
        "subtitle": "Jaa, niin useampi myyjä alueillasi näkee kiinnostuksesi.",
        "shareButton": "Jaa nyt",
        "skipButton": "Ehkä myöhemmin"
      },
      "main": {
        "locationTitle": "Sijainti",
        "chooseLocation": "Valitse sijainti",
        "selectLocationError": "Valitse rakennus tai alue julkaistaksesi kiinnostuksesi.",
        "expandArea": "Laajenna kiinnostusaluettasi",
        "within500m": "500 m säteellä",
        "chooseOnMap": "Valitse alueet",
        "descriptionLabel": "Kuvaus",
        "anyDescription": "Ei kuvausta",
        "descriptionPlaceholder": "Kerro tarkemmin, millaisesta kodista olet kiinnostunut...",
        "sizeLabel": "Koko",
        "anySize": "Mikä tahansa koko",
        "roomsLabel": "Huoneet",
        "anyRooms": "Mikä tahansa määrä",
        "roomsUnit": "huonetta",
        "anyTab": "Kaikki",
        "roomsFlexible": "Joustava +/- 1 huone",
        "priceLabel": "Hinta",
        "anyPrice": "Mikä tahansa hinta",
        "minPlaceholder": "Min",
        "maxPlaceholder": "Max",
        "includeUnpriced": "Sisällytä hinnoittelemattomat",
        "floorLabel": "Kerros",
        "anyFloor": "Mikä tahansa kerros",
        "floorHighest": "Ylin kerros",
        "floorMid": "Keskikerrokset",
        "floorLowest": "Alin kerros",
        "renovationLabel": "Kunto",
        "anyRenovation": "Mikä tahansa kunto",
        "renovationRecent": "Hiljattain remontoitu",
        "renovationGood": "Hyvä kunto",
        "renovationNeeds": "Remontoitava",
        "amenitiesLabel": "Mukavuudet",
        "anyAmenities": "Lisää mukavuuksia",
        "amenityElevator": "Hissi",
        "amenityBalcony": "Parveke / Terassi",
        "postButton": "Julkaise kiinnostuksesi",
        "saveButton": "Tallenna muutokset"
      },
      "mapPicker": {
        "title": "Sijainti",
        "subtitle": "Valitse rakennus tai kaupunginosa.",
        "searchPlaceholder": "Hae",
        "recenterAria": "Keskitä tähän kotiin",
        "myLocationAria": "Näytä sijaintini",
        "zoomAria": "Lähennä tai loitonna",
        "zoomInAria": "Lähennä",
        "zoomOutAria": "Loitonna",
        "unselectBuildingAria": "Poista rakennuksen valinta",
        "removeAreaAria": "Poista {{name}}",
        "loadingAreas": "Ladataan alueita…",
        "areasUnavailable": "Alueita ei voitu ladata kokonaan. Liikuta karttaa tai yritä myöhemmin uudelleen.",
        "done": "Valmis"
      },
      "myAreas": {
        "title": "Omat alueet",
        "empty": "Ei tallennettuja ostamisalueita.",
        "loadError": "Alueiden lataaminen epäonnistui.",
        "retry": "Yritä uudelleen",
        "circleLabel": "500 m säde",
        "circleAround": "{{address}} ± 500 m",
        "noAreas": "Ei valittuja alueita",
        "anyCriteria": "Kaikki kohteet",
        "roomsValue": "{{count}}+ huonetta",
        "notifyEmail": "Sähköposti",
        "notifySms": "Tekstiviesti",
        "notifyNone": "Ei ilmoituksia",
        "editButton": "Muokkaa",
        "deleteButton": "Poista",
        "confirmDelete": "Vahvista poisto"
      }
    }
  },
  "common": {
    "showMore": "Näytä lisää",
    "showLess": "Näytä vähemmän",
    "readMore": "Lue lisää...",
    "readLess": "Näytä vähemmän",
    "back": "Takaisin",
    "address": "Katuosoite",
    "close": "Sulje",
    "findingLocation": "Ladataan sijaintiasi...",
    "cancel": "Peruuta",
    "optional": "valinnainen",
    "yes": "Kyllä",
    "no": "Ei",
    "retry": "Yritä uudelleen",
    "error": "Tapahtui virhe. Yritä uudelleen.",
    "loading": "Ladataan...",
    "next": "Seuraava",
    "previous": "Edellinen",
    "edit": "Muokkaa",
    "remove": "Poista",
    "forSale": "Voisin myydä"
  },
  "propertyMap": {
    "title": "Asuntokartta",
    "subtitle": "Osta tai myy kotisi helposti. Keskustele yksityisesti toisen osapuolen kanssa.",
    "explore": "Avaa kartta",
    "exploreHintSmallScreen": "Klikkaa mitä vain rakennusta",
    "exploreHintLargeScreen": "Klikkaa mitä vain rakennusta kartalla",
    "approximateLocationHint": "Selaimesi jakoi vain likimääräisen sijainnin, joten kartan sijainti voi olla epätarkka.",
    "approximateLocationHintIosChrome": "Chrome jakoi vain likimääräisen sijainnin. Ota iPhonen Chrome-sovellukselle tarkka sijainti käyttöön, jos haluat täsmällisemmän sijainnin kartalle."
  },
  "feed": {
    "title": "Viimeisimmät tapahtumat",
    "button": {
      "showFeed": "Avaa",
      "hideFeed": "Sulje"
    },
    "likeBuildingEvent": {
      "text": "Käyttäjä tykkäsi talosta"
    },
    "offMarketWillingnessEvent": {
      "sell": {
        "text": "Voisin myydä"
      },
      "buy": {
        "text": "Kiinnostunut ostaja"
      }
    },
    "sellerBuyerOverlapEvent": {
      "text": "Myyjät ja ostajat samassa talossa!"
    }
  },
  "map": {
    "showMap": "Näytä asuntokartta",
    "showFeed": "Näytä asuntofiidi"
  },
  "mainMenu": {
    "whatIsJaakko": "Mikä Jaakko.com on?",
    "contact": "Yhteystiedot",
    "termsConditions": "Käyttöehdot",
    "privacyPolicy": "Tietosuoja",
    "cookies": "Evästeet",
    "cookieSettings": "Evästeasetukset",
    "language": "Kieli",
    "feedback": "Anna palautetta",
    "copyright": "© 2026 Jaakkocom Oy"
  },
  "building": {
    "controls": {
      "follow": "Seuraa",
      "share": "Jaa",
      "like": "Tykkää",
      "more": "Lisää"
    },
    "view": {
      "buyer": "ostaja",
      "buyers": "ostajaa",
      "likes": "tykkäystä",
      "views": "katselua",
      "follower": "seuraaja",
      "followers": "seuraajaa",
      "learnMore": "Lue lisää",
      "emptyPrompt": "Ole ensimmäinen, joka myy tai osoittaa kiinnostuksensa ostaa täällä.",
      "buyersHint_one": "Täällä on <b>{{count}}</b> ostaja kodille. Ole ensimmäinen myyjä.",
      "buyersHint_other": "Täällä on <b>{{count}}</b> ostajaa kodille. Ole ensimmäinen myyjä.",
      "sellersHint_one": "Tässä talossa on <b>{{count}}</b> myyjä. Ole ensimmäinen ostaja.",
      "sellersHint_other": "Tässä talossa on <b>{{count}}</b> myyjää. Ole ensimmäinen ostaja.",
      "sellers": "Myynnissä tässä talossa",
      "buyersTitle": "Kiinnostuneet ostajat",
      "buildingInfo": "Talon tiedot",
      "buyerBadge": "Ostaja",
      "addImage": "Lisää kuva",
      "lookingFor": "Etsii",
      "suggest": "Ehdota",
      "share": "Jaa",
      "sellHere": "Myy täällä",
      "buyHere": "Osta täällä",
      "youAreSellingHere": "Myyt täällä",
      "youHaveBuyingInterestHere": "Sinulla on ostokiinnostus täällä",
      "viewMap": "Näytä kartta",
      "getAlerts": "Ilmoitukset",
      "alertsError": "Ilmoitusten päivittäminen epäonnistui. Yritä uudelleen.",
      "likeError": "Tykkäyksen päivittäminen epäonnistui. Yritä uudelleen.",
      "alertsAddressPending": "Odotetaan rakennuksen osoitetta.",
      "alertsNoStreet": "Ilmoitukset vaativat katuosoitteen.",
      "noStreetAddress": "Ei katuosoitetta",
      "sellersCtaTitle": "Etkö löytänyt etsimääsi?",
      "sellersCtaBody": "Kerro muille, mitä etsit.",
      "addBuyingInterest": "Lisää ostokiinnostus",
      "buyersCtaBody": "Omistatko kodin tässä talossa? On hyvä mahdollisuus, että joku on kiinnostunut ostamaan sen.",
      "iCouldSell": "Voisin myydä",
      "previewNoMatchingListings": "Tässä rakennuksessa ei ole suodattimiasi vastaavia ilmoituksia.",
      "previewEmptyInterest": "Ole ensimmäinen, joka osoittaa kiinnostusta myydä tai ostaa tässä rakennuksessa.",
      "cornerBuilding": "Kulmatalo, myös osoitteessa {{street}}",
      "frontagesMore": "+{{n}} lisää",
      "frontagesMoreAria": "Näytä {{n}} lisää: {{streets}}",
      "frontagesLess": "Näytä vähemmän"
    },
    "generalInfo": {
      "property": "Kohde",
      "plot": "Tontti",
      "redemptionClause": {
        "title": "Lunastuspykälä",
        "yes": "Kyllä",
        "no": "Ei"
      },
      "plotOwnership": {
        "title": "Tontti",
        "owned": "Oma",
        "rented": "Vuokra"
      }
    },
    "apartments": {
      "title": "Huoneistot",
      "units": {
        "count": "{{count}} kpl",
        "countEmpty": "- kpl"
      },
      "roomCount": "{{count}}h",
      "fourPlusRooms": "4h+"
    },
    "offMarket": {
      "title": "Asuntokauppa",
      "emptyPlaceholder": {
        "firstLine": "Ei vielä kiinnostuksia.",
        "secondLine": "Voisitko myydä tai ostaa täältä? Paina nappia. ☝️"
      },
      "couldSell": "Voisin myydä",
      "couldBuy": "Voisin ostaa",
      "shareTitle": {
        "couldSell": "Voisin myydä",
        "couldBuy": "Ostokiinnostus"
      },
      "sharedEvent": {
        "sellTitle": "Myyntikiinnostus",
        "buyTitle": "Ostokiinnostus",
        "description": "Tämä ilmoitus on jaettu sinulle."
      },
      "count_one": "{{count}} kpl",
      "count_other": "{{count}} kpl",
      "infoButton": "Mitä nämä ovat",
      "infoModalText": "Voisitko myydä tai haluaisitko ostaa täältä? Ilmaise kiinnostuksesi napin painalluksella – helpommin kuin koskaan! Yhdistämme sinut vastapuolen kiinnostuneisiin ilman sitoumuksia. Keskustelu välillänne aukeaa suoraan Omat viestit-osiossa ja sähköpostiosoitteesi näytetään toiselle osapuolelle vain, jos päätät lähettää viestin tai vastata saamaasi tiedusteluun. Voit myös poistaa kiinnostuksesi milloin tahansa. <1>Lue lisää...</1>",
      "toast": {
        "couldSellNoBuyers": "Hienoa! Kun kiinnostunut ostaja löytyy, saat tiedon sähköpostiisi.",
        "couldSellAndBuyers": "Myös ostajat ovat kiinnostuneita, voitte nyt keskustella Viestit-osiossa!",
        "couldBuyNoSellers": "Hienoa! Kun kiinnostunut omistaja löytyy, saat tiedon sähköpostiisi.",
        "couldBuyAndSellers": "Myös omistajat ovat kiinnostuneita, voitte nyt keskustella Viestit-osiossa!",
        "userSellerAndBuyer": "Myyminen ja ostaminen samassa talossa ei ole vielä mahdollista. Tuomme tämän ominaisuuden saataville lähiaikoina.",
        "sellListingsLimitReached": "Olet saavuttanut uusien myynti-ilmoitusten rajan.",
        "couldBuyLimitReached": "Osto-kiinnostusten raja saavutettu. <1>Vahvista henkilöllisyytesi</1> saadaksesi rajattomat ehdotukset."
      },
      "modal": {
        "sell": {
          "title": "Voisin myydä",
          "description": "Osoita myyntikiinnostuksesi, niin yhdistämme sinut mahdollisiin ostajiin. Käyttö on maksutonta eikä sido mihinkään."
        },
        "buy": {
          "title": "Voisin ostaa",
          "description": "Osoita ostokiinnostuksesi, niin yhdistämme sinut myyjiin. Käyttö on maksutonta eikä sido mihinkään."
        },
        "edit": {
          "menuTitle": "Muokkaa",
          "title": "Muokkaa ilmoitusta",
          "sellDescription": "Päivitä myyntikiinnostuksesi tiedot.",
          "buyDescription": "Päivitä ostokiinnostuksesi tiedot."
        },
        "confirm": "Vahvista",
        "delete": "Poista",
        "deleteConfirmTitle": "Poista ilmoitus",
        "deleteConfirmText": "Haluatko varmasti poistaa tämän ilmoituksen?",
        "remove": {
          "menuTitle": "Poista"
        },
        "removeSell": {
          "title": "Miten myynti sujui?",
          "subtitle": "Autathan meitä parantamaan palvelua kertomalla syyn ilmoituksesi poistamiseen.",
          "reasons": {
            "SOLD_VIA_JAAKKO": "Sain myytyä Jaakossa",
            "SOLD_ELSEWHERE": "Sain myytyä muualla",
            "NO_LONGER_SELLING": "En ole enää myymässä",
            "JUST_TESTING_INTEREST": "Halusin vain kokeilla kiinnostusta",
            "NOT_ENOUGH_CONTACTS": "En saanut riittävästi yhteydenottoja / sopivia ostajia",
            "PREFER_NOT_TO_SAY": "En halua sanoa",
            "OTHER": "Jokin muu, mikä?"
          },
          "otherPlaceholder": "Kerro lisää...",
          "confirmButton": "Poista ilmoitus",
          "cancelButton": "Peruuta",
          "closeLabel": "Sulje"
        },
        "update": "Päivitä",
        "cancel": "Peruuta",
        "detailsOptional": "Asunnon tiedot (Valinnainen)",
        "description": "Kuvaus",
        "buyingInterestDescriptionPlaceholder": "Lisää tietoja asunnoista, joista olet kiinnostunut...",
        "sellingInterestDescriptionPlaceholder": "Lisää tietoja asunnosta, jonka voisit myydä...",
        "additionalDetails": "Anna lisätietoja (valinnainen)",
        "size": "Koko (m²)",
        "sizePlaceholder": "esim. 65",
        "sizeClass": "Kokoluokka (m²)",
        "rooms": "Huonetta",
        "rooms_one": "Huone",
        "rooms_other": "Huonetta",
        "roomsLabel": "Huoneita",
        "selectRooms": "Valitse huoneiden määrä",
        "buildingType": "Rakennustyyppi",
        "selectBuildingType": "Valitse rakennustyyppi",
        "apartmentBuilding": "Kerrostalo",
        "detachedHouse": "Omakotitalo",
        "other": "Muu",
        "terracedHouse": "Rivitalo",
        "duplex": "Paritalo",
        "floor": "Kerros",
        "floorPlaceholder": "esim. 3",
        "renovation": "Remonttitilanne",
        "selectRenovation": "Valitse kunto",
        "recentlyRenovated": "Äskettäin remontoitu",
        "goodCondition": "Hyvä kunto",
        "needsRenovation": "Remontin tarpeessa",
        "hasElevator": "Hissi",
        "hasBalcony": "Parveke/terassi",
        "address": "Katuosoite",
        "addressPlaceholder": "Esim. Keskuskatu 1, 00100 Helsinki",
        "selectBuildingOnMap": "Klikkaa oikeaa rakennusta kartalla jatkaaksesi",
        "loading": "Ladataan...",
        "checkingBuilding": "Tarkistetaan rakennusta...",
        "buildingFound": "Rakennus löytyi tästä osoitteesta",
        "sellInterestNoBuildingFound": "Rakennusta ei löytynyt, lisää myyntikiinnostuksesi Asuntokartta-toiminnon kautta.",
        "buyInterestNoBuildingFound": "Rakennusta ei löytynyt, lisää ostokiinnostuksesi Asuntokartta-toiminnon kautta.",
        "incompleteAddress": "Valitse valikosta koko osoite, myös talon numero ja kaupunki, esim. Keskuskatu 1, Helsinki. Voit valita talon myös Asuntokartalta.",
        "addPropertyImages": "Lisää kuvia asunnosta (Max. 30)",
        "dragImagesHere": "Valitse tiedosto tai pudota tähän",
        "propertyImage": "Kuva asunnosta",
        "removeImage": "Poista kuva",
        "uploadFailed": "Lataus epäonnistui",
        "unsupportedImage": "Tiedostotyyppiä ei tueta.",
        "coverPhoto": "Pääkuva",
        "dragToReorder": "Vedä järjestääksesi",
        "reorderHint": "Vedä kuvia ikonista vaihtaaksesi järjestystä",
        "reorderHintMobile": "Paina ja pidä järjestääksesi kuvat",
        "selectImagesToRemove": "Valitse kuvia poistettavaksi",
        "selectImage": "Valitse kuva",
        "removeSelected": "Poista {{count}} valittua",
        "removeSelected_one": "Poista 1 valittu",
        "removeSelected_other": "Poista {{count}} valittua",
        "selectImages": "Valitse kuvia",
        "imageLimitExceeded": "Max. {{max}} kuvaa sallittu",
        "fileTooLarge": "Jotkin tiedostot ylittävät enimmäiskoon {{max}}. Käytä pienempiä kuvia.",
        "aiEnhance": "AI-parannus",
        "enhancementsRemaining": "{{count}} parannusta jäljellä",
        "dailyLimitReached": "Päivittäinen parannusraja saavutettu",
        "creditsRemaining": "{{count}} kuvaa jäljellä",
        "buyCredits": "Osta kuvia",
        "creditsAvailable": "{{count}} kuvaa jäljellä",
        "noCreditsAvailable": "Ei kuvia jäljellä",
        "creditsPricing": "Kuvien stailaus nyt vain 4,90 € \n- 50% etu!",
        "purchaseError": "Oston aloitus epäonnistui. Yritä uudelleen.",
        "processing": "Käsitellään...",
        "showOriginal": "Käytä alkuperäistä kuvaa",
        "showEnhanced": "Käytä parannettua kuvaa",
        "regenerate": "Luo uudelleen",
        "regenerating": "Luodaan uudelleen...",
        "regenerateCreditInfo": "Käyttää 1 krediitin · {{count}} jäljellä",
        "regenerateNoCreditInfo": "Krediitit lopussa - luo uudelleen ostaaksesi lisää",
        "enhanceThisImage": "Paranna tämä kuva",
        "enhancing": "Parannellaan...",
        "noEnhancementCreditsLeft": "Krediitit lopussa",
        "buyCreditsToEnhance": "Osta krediittejä parantaaksesi tämän kuvan.",
        "enhanced": "Parannettu",
        "original": "Alkuperäinen",
        "enhancementFailed": "Parannus ei saatavilla",
        "or": "Tai käytä alkuperäisiä kuvia",
        "aiEnhancementTitle": "Myy kotisi nopeammin upeilla kuvilla",
        "aiEnhancementDescription": "Laadukkaat kuvat voivat jopa <1>kolminkertaistaa myyntimahdollisuutesi</1>. Jaakko siivoaa ja stailaa kotisi sekunneissa: siistimpi koti, tyylikkäämpi sisustus ja kirkkaampi valaistus.",
        "aiEnhancementDescriptionReadMoreLink": "Lue lisää ja katso ero ennen ja jälkeen.",
        "aiEnhancementNormalPrice": "\nNorm. 9,90 € / 60 kuvaa.",
        "uploadAndEnhance": "Valitse kuvat",
        "pickPhotos": "Valitse kuvat",
        "takePhotos": "Ota kuva",
        "buyCreditsButton": "Osta kuvia",
        "pleaseSelectAddress": "Valitse osoite",
        "sellInterestRegistered": "Myyntikiinnostuksesi on rekisteröity onnistuneesti!",
        "buyInterestRegistered": "Ostokiinnostuksesi on rekisteröity onnistuneesti!",
        "submitError": "Virhe lähetettäessä. Yritä uudelleen.",
        "sellListingsLimitReached": "Olet saavuttanut uusien myynti-ilmoitusten rajan.",
        "automaticEstimateDailyLimit": "Olet käyttänyt kaikki päivän automaattiset hinta-arviot.",
        "alreadySellingInBuilding": "Sinulla on jo ilmoitus tässä talossa. Muokkaa ilmoitusta tai poista se ja lisää uudelleen.",
        "sizeMustBeGreaterThanZero": "Virheellinen koko.",
        "clickBuildingInstruction": "Valitse vielä oikea rakennus osoitteesta kartalta.",
        "buildingSelected": "Rakennus valittu",
        "receivedAddress": "Rakennuksen osoite:",
        "askingPrice": "Hintapyyntö (€)",
        "optional": "(valinnainen)",
        "pricePlaceholder": "esim. 250 000",
        // "startPriceEstimation": "Pyydä Jaakolta kattava hinta-arvio raportti asunnostasi. Arvio valmistuu 10-20 minuutissa.",
        "startPriceEstimation": "Jaakon ilmainen hinta-arvio",
        "startPriceEstimationBuildingPage": "Ilmainen hinta-arvio asunnosta",
        "estimatingPrice": "Arvioidaan asunnon hintaa...",
        "emailWhenReady": "Löydät hinta-arvion \"Profiili\" -sivulta, kun raportti on valmis. Palaa takaisin noin 20 minuutin kuluttua. Saat tiedon valmistumisesta myös sähköpostiisi.",
        "selectBuildingFirst": "Viimeistele ensin osoitteen lisääminen.",
        "estimationReady": "Hinta-arvio valmis",
        "viewFullReport": "Näytä raportti",
        "estimationFailed": "Hinta-arvio epäonnistui",
        "priceEstimation": {
          "notAvailable": "Ei saatavilla"
        },
        "firstPhotosFreeOfCharge": "60 stailattua kuvaa ilmaiseksi! 🎉",
        "before": "Ennen",
        "after": "Jälkeen",
        "estimationError": {
          "daily_limit_reached": "Olet käyttänyt hinta-arviosi tälle päivälle. Saat huomenna uudet ilmaiset hinta-arviot. Kehitämme palvelua. Jatkossa voit ostaa lisää hinta-arvioita jokaiselle päivälle. "
        },
        "preEstimationTitle": "Arvioidaan asuntosi hinta",
        "preEstimationSubtitle": "Anna vähintään asunnon koko, huoneiden määrä ja rakennustyyppi, jotta saat tarkan arvion. Mitä enemmän tietoja lisäät, sitä parempi!",
        "preEstimationTip": "Vinkki: Kerro myös kerros, asunnon kunto, parveke, hissi tai lyhyt kuvaus — näillä parannat tarkkuutta.",
        "preEstimationBack": "Takaisin",
        "startEstimation": "Käynnistä arviointi",
        "estimationTime": "Hinta-arvio ja raportti valmistuvat yleensä n. 15–20 minuutissa. Saat kolme ilmaista arviota per päivä. Raportti tuotetaan automaattisesti käytettävissä olevan tiedon perusteella.",
      },
      "template": {
        "loading": "Ladataan asetuspohjaa...",
        "usingTemplate": "Tallennetut ostoasetukset",
        "clear": "Tyhjennä asetuspohja",
        "update": "Päivitä ostoasetuksia",
        "save": "Tallenna ostoasetukset",
        "updateTemplate": "Päivitä ostoasetuksia",
        "saveAsTemplate": "Tallenna ostoasetukset",
        "moreInfo": "Lisätietoja",
        "tooltipText": "Tallenna ostoasetukset myöhempään käyttöön toisissa kohteissa",
        "deleteConfirmTitle": "Poista asetuspohja",
        "deleteConfirmText": "Oletko varma, että haluat poistaa ostoasetukset?",
        "delete": "Poista",
        "cancel": "Peruuta"
      },
    },
    "housingCompanyHoldings": {
      "title": "Taloyhtiön omistukset",
      "apartments": "Huoneistoja",
      "commercialSpaces": "Liiketiloja",
      "units": "kpl"
    },
    "jaakko": {
      "sendFeedback": "Lähetä palautetta",
      "error": "Hups. Jotain meni pieleen.",
      "title": "Jaakon huomiot"
    },
    "housingCompanyInfo": {
      "title": "Taloyhtiön lisätiedot"
    },
    "map": {
      "title": "Kartta"
    },
    "comments": {
      "title": "Yleinen keskustelu",
      "emptyState": "<0>Täällä voit keskustella talosta julkisesti.</0><1>Aloita keskustelu! 🥳</1>",
      "placeholder": "Jaa kokemuksesi talosta, lisää kuva tai kysy jotain.",
      "send": "Lähetä",
      "back": "Takaisin",
      "pickPhoto": "Valitse kuva",
      "takePhoto": "Ota kuva",
      "commenterOrderNumberFirst": "Eka."
    },
    "filesDropBox": {
      "title": "Lataa yhtiöjärjestys, tilinpäätös, kunnossapitotarveselvitys tai muita liittyviä dokumentteja."
    },
    "documentDropzone": {
      "clickToUpload": "<0>Valitse tiedosto</0> <2>tai pudota tähän</2>",
      "termsAgreement": "Lähettämällä dokumentteja sitoudut noudattamaan palveluidemme <1>käyttöehtoja</1>, sekä ilmoitat lukeneesi ja hyväksyväsi Jaakkocom Oy:n <3>yleisen tietosuojakuvauksen</3>.",
      "buttonText": "Analysoi",
      "loading": {
        "title": "Koostan raporttia tietojen pohjalta.",
        "text": "Tässä voi mennä muutama minuutti..."
      }
    },
    "buildingInfoBox": {
      "title": "Taloyhtiö"
    },
    "financialsInfoBox": {
      "title": "Talous"
    },
    "renovationsInfoBox": {
      "title": "Remontit"
    },
    "maintenanceNeedsAssessmentPlaceHolderText": "Syötä taloyhtiön kunnossapitotarveselvitys, tai PTS -suunnitelma, saadaksesi analyysin",
    "articlesOfAssociationPlaceHolderText": "Syötä taloyhtiön yhtiöjärjestys, saadaksesi analyysin",
    "financialStatementPlaceHolderText": "Syötä taloyhtiön tilinpäätös, tai talousarvio, saadaksesi analyysin",
    "streetView": {
      "title": "Katunäkymä"
    }
  },
  "mainMenuPages": {
    "faq": {
      "title": "Usein kysytyt kysymykset",
      "whatIsJaakko": {
        "title": "Mikä Jaakko.com on?",
        "paragraphs": {
          "first": "Jaakko.com on uudenlainen palvelu, joka yhdistää ostajat ja myyjät toisiinsa helpommin kuin koskaan, ilman sitoumuksia. Jos et löydä kiinnostavaa kohdetta nykyisistä palveluista tai harkitset myymistä ilman raskasta ja monimutkaista prosessia, Jaakko.com tarjoaa yksinkertaisen ja tehokkaan tavan uudenlaiselle kaupankäynnille.",
          "second": "Käyttäjät voivat myös keskustella, jakaa tietoa ja kuvia sekä esittää kysymyksiä mistä tahansa rakennuksesta. Keskustelun avulla voi oppia lisää eri kohteista ja saada arvokasta näkemystä muilta käyttäjiltä.",
        }
      },
      "sellingAndBuying": {
        "title": "Ostaminen ja myyminen Jaakko.comin kautta",
        "howItWorks": {
          "title": "Miten se toimii?",
          "bulletPoints": {
            "express": "Valitse talo kartalta ja ilmaise kiinnostuksesi ostamiseen tai myymiseen yhdellä napin painalluksella. Muille käyttäjille näkyy vain, että joku talosta saattaa olla valmis keskustelemaan – ei muuta. Voit halutessasi lisätä myyntikiinnosukseesi lisätietoja ja kuvia, jolloin ostajat saavat heti parhaan käsityksen kohteesta suoraan asuntofiidissä.",
            "connect": "Kun kiinnostus on molemminpuolista, saat tiedon sähköpostiisi, ja osapuolille avautuu suora keskustelumahdollisuus palvelussa.",
            "anonymous": "Kaikki on aluksi täysin anonyymiä – sähköpostiosoitteesi jaetaan vasta, jos päätät vastata vastapuolen yhteydenottoon tai lähettää itse viestin.",
            "information": "Voit aloittaa keskustelun esimerkiksi kertomalla, mikä sinua kiinnostaa, kuten \"Voisin myydä 2h\" tai \"Etsin perheasuntoa talosta\".",
            "removeinterest": "Voit koska tahansa poistaa kiinnostuksesi yhdellä napin painalluksella, jolloin uusia yhteydenottoja ei enää tule.",
            "removechat": "Voit poistaa minkä tahansa keskustelun koska tahansa. Tällöin et enää saa viestejä kyseiseltä vastapuolelta."
          },
        },
        "safety": {
          "title": "Huomioithan turvallisuuden ja hyvät tavat:",
          "bulletPoints": {
            "first": "Jaakko.com on tarkoitettu yhteyksien luomiseen – palvelu ei osallistu varsinaiseen kaupankäyntiin eikä varmista osapuolten henkilöllisyyttä.",
            "second": "Varmista aina vastapuolen henkilöllisyys ennen päätöksiä tai maksuja. Tämä voi tapahtua esimerkiksi tapaamalla kasvotusten tai pyytämällä virallisia asiakirjoja.",
            "third": "Käytä tarvittaessa asiantuntijoita, kuten välittäjää tai juristia, varmistaaksesi turvallisen kaupanteon.",
            "fourth": "Viesteissä ei saa esittää loukkaavia, laittomia, häiritseviä tai valheellisia väitteitä, eikä mitään sisältöä, joka rikkoo lakeja tai hyviä tapoja.",
            "fifth": "Jaakko.com pidättää oikeuden poistaa keskusteluja ja käyttäjiä, jotka rikkovat palvelun sääntöjä tai hyviä tapoja.",
            "sixth": "Noudattamalla näitä ohjeita varmistat, että palvelun käyttö on turvallista ja mukavaa kaikille osapuolille."
          }
        }
      },
      "benefits": {
        "title": "Mitä hyötyä Jaakko-tunnuksesta on?",
        "paragraphs": {
          "first": "Voit selata rakennuksia ilman tunnusta, mutta Jaakko-tunnuksella saat käyttöösi lisäominaisuuksia:",
          "second": "Jaakko-tunnuksen luominen on maksutonta ja vie vain minuutin!"
        },
        "bulletPoints": {
          "first": "Ilmaise kiinnostuksesi myymiseen tai ostamiseen missä tahansa rakennuksessa.",
          "second": "Osallistu keskusteluun ja jaa kokemuksia.",
          "third": "Seuraa kiinnostavia kohteita ja saa ilmoituksia uusista tiedoista.",
          "fourth": "Jaa taloja ystäviesti kanssa.",
          "fifth": "Tykkää kiinnostavia taloja."
        }
      },
      "howToParticipate": {
        "title": "Miten osallistun keskusteluun?",
        "paragraph": "Keskustelu ja kuvien jakaminen palvelussa on anonyymiä, mutta edellyttää Jaakko-tunnusta. Keskusteluissa tulee noudattaa hyviä tapoja, eikä niissä saa mainita omia tai muiden nimiä tai muita yhteystietoja. Lisäksi keskusteluissa ei saa esittää loukkaavia, laittomia, häiritseviä tai valheellisia väitteitä, eikä mitään sisältöä, joka rikkoo lakeja tai hyviä tapoja."
      },
      "typesOfRealEstate": {
        "title": "Minkälaisia kohteita Jaakko kattaa?",
        "paragraph": "Karttapohjainen käyttöliittymä mahdollistaa tutustumisen rakennuksiin, keskustelun ja osto- ja myyntikiinnostuksen osoittamisen kaikkialla maailmassa. Mikäli kohteella ei ole tarkkaa osoitetta (kesämökit saarissa, jne.), puuttuvat ne palvelusta vielä osittain."
      },
      "payments": {
        "title": "Maksullisuus",
        "paragraph": "Palvelun perustoiminnot ovat veloituksettomia, mutta tietyistä ominaisuuksista ja lisäpalveluista voidaan tulevaisuudessa periä maksu. Palvelun veloitukseton käyttö ei velvoita jatkossa mihinkään."
      },
      "feedback": {
        "title": "Miten voin antaa palautetta?",
        "paragraph": "Kaikki palaute on tervetullutta. Voit lähettää palautteesi osoitteeseen support@jaakko.com. Kehitämme palvelua jatkuvasti ja arvostamme käyttäjien näkemyksiä."
      }
    },
    "contactUs": {
      "title": "Yhteystiedot",
      "customerSupport": "Asiakaspalvelu:",
      "businessId": "Y-tunnus:",
      "country": "Suomi"
    }
  },
  "signupLoginModal": {
    "backAria": "Takaisin",
    "closeAria": "Sulje",
    "loginOrSignup": "Kirjaudu tai luo tunnus",
    "continueWithGoogle": "Jatka Googlella",
    "continueWithFacebook": "Jatka Facebookilla",
    "orContinueWithEmail": "tai jatka sähköpostilla",
    "loginOrSignupButton": "Seuraava",
    "login": "Kirjaudu",
    "passwordPlaceholder": "Salasana",
    "loginButton": "Seuraava",
    "logout": "Kirjaudu ulos",
    "logoutButton": "Kirjaudu ulos",
    "emailPlaceholder": "Sähköposti",
    "infoBox": {
      "title": "Aloita ilmaiseksi – <tail>jo <count/> kohdetta!</tail>",
      "bulletPoints": {
        "freeAccount": "Luo tunnus sekunneissa – ilman sitoumuksia.",
        "noFees": "Ei välityspalkkiota eikä välikäsiä – säästä tuhansia euroja.",
        "anywhere": "Jätä ostokiinnostus mihin tahansa kotiin."
      },
      "testimonial": {
        "quote": "Asunto oli ollut myynnissä yli vuoden eri välittäjien kautta, mutta ostajaa ei löytynyt. Jaakon kautta oikea ostaja löytyi nopeasti.",
        "author": "Sarita, Helsinki",
        "saving": "15 000 € säästö välityspalkkiossa"
      }
    },
    "registerText": {
      "first": "Rekisteröitymällä luot Jaakko-tunnuksen ja sitoudut noudattamaan palveluidemme ",
      "second": "käyttöehtoja",
      "third": ", sekä ilmoitat lukeneesi ja hyväksyväsi Jaakkocom Oy:n ",
      "fourth": "yleisen tietosuojakuvauksen."
    },
    "passwordRequirements": {
      "length": "Salasanan täytyy olla vähintään 8 merkkiä pitkä.",
      "uppercase": "Salasanan täytyy sisältää vähintään yksi iso kirjain.",
      "lowercase": "Salasanan täytyy sisältää vähintään yksi pieni kirjain.",
      "number": "Salasanan täytyy sisältää vähintään yksi numero."
    },
    "checkPassword": "Tarkista salasana.",
    "unexpectedError": "Hups! Jotain meni pieleen.",
    "signup": {
      "title": "Luo tunnus",
      "accountExists": "Näyttää siltä, että sinulla on jo tunnus. Kirjaudu sisään.",
      "signupButton": "Seuraava",
      "marketingConsent": "Haluan vastaanottaa Jaakolta sähköpostia uutisista ja mahdollisuuksista"
    },
    "emailVerification": {
      "title": "Vahvista sähköpostiosoite",
      "firstParagraph": "Anna vahvistuskoodi",
      "secondParagraph": "Anna koodi, joka lähetettiin sähköpostiosoitteeseesi {{email}} (jos et näe sähköpostia, tarkista roskapostikansio)",
      "codePlaceholder": "Vahvistuskoodi",
      "resendCode": "Lähetä koodi uudelleen",
      "resendSuccess": "Uusi koodi on lähetetty sähköpostiisi.",
      "smsVerifyLink": "Etkö saanut koodia? Vahvista tekstiviestillä.",
      "smsTitle": "Vahvista tekstiviestillä",
      "smsSubtitle": "Anna koodi, joka lähetettiin numeroon {{phone}}",
      "phonePlaceholder": "+358 40 123 4567",
      "sendSmsButton": "Lähetä koodi tekstiviestillä",
      "smsSentSuccess": "Koodi lähetetty numeroon {{phone}}",
      "smsError": "Tekstiviestin lähetys epäonnistui. Yritä uudelleen.",
      "invalidPhone": "Anna kelvollinen suomalainen puhelinnumero.",
      "submitButton": "Vahvista",
      "rateLimitError": "Liian monta yritystä. Odota hetki ja yritä uudelleen.",
      "tooManyAttempts": "Liian monta väärää koodia. Pyydä uusi koodi sähköpostilla.",
      "sessionRequired": "Käytä tekstiviestivaihtoehtoa selaimessa, jossa rekisteröidyit, tai lähetä koodi uudelleen sähköpostilla."
    },
    "forgotPassword": {
      "linkText": "Unohditko salasanasi?",
      "title": "Uusi salasana",
      "subtitle": "Syötä sähköpostiosoitteesi, niin lähetämme sinulle linkin salasanan uusimiseksi.",
      "submitMessage": "Jos tällä sähköpostiosoitteella on luotu tunnus, sinne on lähetetty salasanan uusimislinkki.",
      "sendLinkButton": "Lähetä uusimislinkki",
      "backToLogin": "Takaisin kirjautumiseen"
    },
    "errors": {
      "existsWithAnotherAuthenticationMethod": "Tämä sähköpostiosoite on rekisteröity toisella kirjautumistavalla. Kirjaudu sisään aiemmin käyttämälläsi kirjautumistavalla.",
      "existsWithGoogle": "Tämä sähköpostiosoite on rekisteröity Google-tilillä. Kirjaudu sisään Google-tilillä.",
      "existsWithFacebook": "Tämä sähköpostiosoite on rekisteröity Facebook-tilillä. Kirjaudu sisään Facebook-tilillä.",
      "existsWithEmailPassword": "Tämä sähköpostiosoite on rekisteröity salasanalla. Kirjaudu sisään salasanallasi.",
      "genericOAuth": "Kirjautuminen epäonnistui. Yritä uudelleen.",
      "networkError": "Verkkovirhe. Tarkista yhteytesi ja yritä uudelleen.",
      "emailCheckFailed": "Sähköpostin vahvistus epäonnistui. Yritä uudelleen.",
      "genericSignupError": "Rekisteröityminen epäonnistui. Yritä uudelleen."
    },
    "resetPasswordPage": {
      "title": "Aseta uusi salasana",
      "newPasswordPlaceholder": "Uusi salasana",
      "confirmPasswordPlaceholder": "Vahvista uusi salasana",
      "submitButton": "Aseta uusi salasana",
      "passwordMismatch": "Salasanat eivät täsmää.",
      "successMessage": "Salasanasi on nollattu onnistuneesti. Voit nyt kirjautua sisään uudella salasanallasi.",
      "invalidLink": "Virheellinen tai vanhentunut salasanan nollauslinkki.",
      "tokenMissing": "Salasanan nollaustunniste puuttuu.",
      "goToLogin": "Siirry kirjautumiseen"
    }
  },
  "metaTags": {
    "title": "Jaakko.com | Asuntokartta & hiljainen myynti",
    "description": "Voisitko myydä asuntosi, tai haluaisitko ostaa? Oman asunnon klikkaaminen hiljaiseen myyntiin, tai seuraavan unelmakodin etsiminen, on nyt helpompaa kuin koskaan.",
    "ogTitle": "Jaakko.com | Asuntokartta & hiljainen myynti",
    "ogDescription": "Voisitko myydä asuntosi, tai haluaisitko ostaa? Oman asunnon klikkaaminen hiljaiseen myyntiin, tai seuraavan unelmakodin etsiminen, on nyt helpompaa kuin koskaan.",
    "building": {
      "title": "Talosivu {{address}} - Jaakko.com",
      "description": "Tutustu {{address}}. Kerro myynti- tai ostokiinnostuksesta, keskustele tai seuraa.",
      "ogTitle": "Tutustu mielenkiintoiseen taloon Jaakko.com:issa",
      "ogDescription": "Tutustu {{address}}. Kerro myynti- tai ostokiinnostuksesta, keskustele tai seuraa."
    }
  },
  "shareButton": {
    "title": "Tutustu mielenkiintoiseen taloon Jaakko.com:issa",
    "text": "Tutustu {{address}}. Kerro myynti- tai ostokiinnostuksesta, keskustele tai seuraa.",
    "linkCopied": "Linkki taloon kopioitu leikepöydälle.",
    "linkCopiedError": "Linkin kopiointi epäonnistui. Kopioi linkki manuaalisesti.",
    "notShareable": "Ei jaettavissa"
  },
  "sharePrompt": {
    "sell": {
      "title": "Hienoa! Olet valmis myymään",
      "description": "Myyntikiinnostuksesi on lisätty. Jaa se löytääksesi ostajia nopeammin!",
      "matchTitle": "Mahtavaa! Myös ostajat ovat kiinnostuneita",
      "matchDescription": "Voitte nyt keskustella \"Omat viestit\" -osiossa. Jaa ilmoituksesi löytääksesi lisää ostajia!"
    },
    "buy": {
      "title": "Hienoa! Olet kiinnostunut ostamaan",
      "description": "Ostokiinnostuksesi on lisätty. Jaa se löytääksesi myyjiä nopeammin!",
      "matchTitle": "Mahtavaa! Myös myyjät ovat kiinnostuneita",
      "matchDescription": "Voitte nyt keskustella \"Omat viestit\" -osiossa. Jaa ilmoituksesi löytääksesi lisää myyjiä!"
    },
    "benefit": {
      "findMatchesSeller": "Enemmän näkyvyyttä",
      "findMatchesBuyer": "Löydä piilossa olevia koteja",
      "reachMoreBuyer": "Lisää potentiaalisia myyjiä",
      "reachMoreSeller": "Lisää potentiaalisia ostajia",
      "faster": "Nopeampi polku kauppoihin"
    },
    "shareButton": "Jaa nyt",
    "skipButton": "Ehkä myöhemmin",
    "boostButton": "Mainosta – 49,90 €",
    "boostSubtitle": "Saat lisää näkyvyyttä kohdennetuilla mainoksilla."
  },
  "boostModal": {
    "sellTitle": "Tehosta kohteesi näkyvyyttä – 49,90 €",
    "buyTitle": "Tehosta ostokiinnostuksesi näkyvyyttä – 49,90 €",
    "description": {
      "sell": "Mainostamme kohdettasi 14 päivän ajan suosituimmissa sosiaalisen median kanavissa. Tavoita alueen potentiaaliset ostajat entistä laajemmin.",
      "buy": "Mainostamme ostokiinnostustasi 14 päivän ajan suosituimmissa sosiaalisen median kanavissa. Tavoitteena on aktivoida lisää myyjiä ja tuoda uusia kohteita tarjolle."
    },
    "emailInfo": "Klikkaa alta, niin saat maksulinkin ja lisätiedot sähköpostiisi.",
    "cancelButton": "Ei kiitos",
    "confirmButton": "Kiinnostaa kuulla lisää",
    "noCommitment": "Tämä ei sido sinua vielä mihinkään.",
    "error": "Pyynnön lähetys epäonnistui. Yritä uudelleen.",
    "or": "tai"
  },
  "messages": {
    "loadTemplate": "Kauppakirjapohja",
    "templateModal": {
      "title": "Kauppakirjapohja",
      "subtitle": "Lataa ammattimainen pohja asuntokaupan viimeistelyyn",
      "description": "Tämä pohja on suunniteltu yksityisiin asuntokauppoihin Suomessa. Se sisältää kaikki olennaiset kentät laillisesti pätevään kauppaan.",
      "features": {
        "title": "Sisältö:",
        "parties": "Ostajan ja myyjän tiedot",
        "property": "Kohteen tiedot",
        "terms": "Maksuehdot ja vastuut",
        "signatures": "Allekirjoituskentät"
      },
      "downloadButton": "Lataa pohja",
      "downloadingButton": "Valmistellaan...",
      "disclaimer": "Sopimuspohja on yleisluontoinen ja tarkoitettu asunto-osakkeille. Jaakko.com ei vastaa sen soveltuuvudesta suoraan yksittäiseen kauppaan.",
      "fileInfo": "Word-dokumentti • Suomen lakimuoto"
    },
    "error": {
      "TOO_MANY_ATTACHMENTS": "Liitetiedostoja ei voi olla enemmän kuin 10",
      "unsupportedFile": "Tiedostotyyppiä ei tueta."
    },
    "title": "Omat viestit",
    "empty": "Luo osto- tai myyntikiinnostus - kun vastapuoli löytyy samasta kohteesta, keskustelu välillänne avautuu tänne.",
    "send": "Lähetä",
    "tabs": {
      "inbox": "Omat viestit",
      "all": "Kaikki",
      "support": "Tuki"
    },
    "draft": {
      "hint": "Kirjoita viesti myyjälle. Hän saa ilmoituksen vasta, kun lähetät viestin.",
      "placeholder": "Kirjoita viesti…",
      "send": "Lähetä"
    },
    "firstMessage": "Keskustelunne alkaa tästä.",
    "welcomeTitle": "Keskustelunne alkaa tästä",
    "welcomeText": "Täällä voitte keskustella asunnon yksityiskohdista ja sopia esimerkiksi näytön ajankohdan. Sähköpostiosoitteesi näkyy toiselle osapuolelle vasta, kun lähetät hänelle viestin.",
    "welcomeTips": "Vinkkejä keskusteluun:",
    "tipPolite": "Ole kohtelias ja kunnioittava",
    "tipCaution": "Älä jaa arkaluontoisia tietoja ennen kuin olet varma toisen osapuolen luotettavuudesta",
    "tipDetails": "Voit lopettaa keskustelun milloin tahansa",
    "writePlaceholder": "Kirjoita viesti... (Ctrl+Enter lähettääksesi)",
    "writePlaceholderMobile": "Kirjoita viesti...",
    "chatEndedPlaceholder": "Tämä keskustelu on päättynyt",
    "chatEndedMessage": "Tämä keskustelu on päättynyt. Uusia viestejä ei voi lähettää.",
    "readStatus": { "sent": "Lähetetty", "seen": "Nähty" },
    "draftNotSentYet": "Olet kirjautunut sisään. Lähetä viesti painamalla Lähetä.",
    "tooLong_one": "Viestisi on pidempi kuin {{max}} merkkiä. Poista {{count}} merkki lähettääksesi.",
    "tooLong_other": "Viestisi on pidempi kuin {{max}} merkkiä. Poista {{count}} merkkiä lähettääksesi.",
    "ownListing": "Tämä on oma kohteesi. Et voi lähettää itsellesi viestiä.",
    "chatEnded": "Keskustelu on päättynyt",
    "endChat": "Lopeta keskustelu",
    "endChatConfirmTitle": "Lopeta keskustelu",
    "endChatConfirmText": "Haluatko varmasti lopettaa tämän keskustelun? Lopettamisen jälkeen kumpikaan osapuoli ei voi enää lähettää viestejä tässä keskustelussa.",
    "confirm": "Lopeta keskustelu",
    "cancel": "Peruuta",
    "ending": "Lopetetaan",
    "today": "Tänään",
    "yesterday": "Eilen",
    "anonymousUser": "Anonyymi käyttäjä",
    "buyer": "Kiinnostunut ostaja",
    "seller": "Kiinnostunut myyjä",
    "buyerParticipant": "Ostajan kutsuttu",
    "sellerParticipant": "Myyjän kutsuttu",
    "pendingInvitee": "tuleva kontakti",
    "someone": "Joku",

    "you": "Sinä",
    "preview": {
      "image_one": "{{count}} kuva",
      "image_other": "{{count}} kuvaa",
      "video_one": "{{count}} video",
      "video_other": "{{count}} videoa",
      "pdf_one": "{{count}} dokumentti",
      "pdf_other": "{{count}} dokumenttia",
      "attachment_one": "{{count}} liite",
      "attachment_other": "{{count}} liitettä"
    },
    "listingRemoved": {
      "title": "Ilmoitus ei ole enää saatavilla",
      "description": "Myyjä on poistanut ilmoituksen. Voit silti jatkaa keskusteluanne."
    },
    "buyInterestRemoved": {
      "title": "Ostokiinnostus ei ole enää saatavilla",
      "description": "Ostaja on poistanut ostokiinnostuksensa. Voit silti jatkaa keskusteluanne."
    },
    "participants": {
      "title": "Osallistujat",
      "addPeople": "Lisää henkilöitä",
      "member": "Jäsen",
      "you": "(sinä)",
      "addedBy": "Lisännyt: {{name}}",
      "pendingInvite": "Kutsu lähetetty",
      "cancelInvite": "Peruuta kutsu",
      "leaveConversation": "Poistu keskustelusta",
      "leaveConfirmTitle": "Poistu keskustelusta?",
      "leaveConfirmText": "Et voi enää lähettää tai vastaanottaa viestejä tässä keskustelussa.",
      "leaveConfirmButton": "Poistu",
      "removeParticipant": "Poista keskustelusta",
      "maxParticipants": "Enintään 4 osallistujaa",
      "participant": "Osallistuja"
    },
    "invite": {
      "title": "Lisää henkilöitä",
      "description": "Ostatko tai myytkö jonkun toisen kanssa? Kutsu heidät mukaan keskusteluun.",
      "emailLabel": "Sähköpostiosoite",
      "emailPlaceholder": "Syötä sähköpostiosoite",
      "replaceWarning": "Tämä peruuttaa odottavan kutsun osoitteeseen {{email}}",
      "sendInvite": "Lähetä kutsu",
      "sending": "Lähetetään...",
      "successExisting": "{{email}} on lisätty keskusteluun",
      "successInvite": "Kutsu lähetetty osoitteeseen {{email}}",
      "successResent": "Kutsu lähetetty uudelleen osoitteeseen {{email}}",
      "errorAlreadyParticipant": "Tämä henkilö on jo keskustelussa",
      "errorAlreadyInvited": "Kutsu on jo lähetetty tähän sähköpostiin",
      "errorAlreadyAddedParticipant": "Olet jo lisännyt osallistujan. Jokainen ostaja ja myyjä voi kutsua vain yhden henkilön.",
      "errorConversationEnded": "Tämä keskustelu on päättynyt eikä uusia osallistujia voi enää lisätä",
      "errorNotOriginalParticipant": "Vain alkuperäinen ostaja tai myyjä voi kutsua osallistujia",
      "errorEmailRequired": "Syötä sähköpostiosoite",
      "errorEmailInvalid": "Syötä kelvollinen sähköpostiosoite",
      "errorJaakkoConversation": "Jaakko-keskusteluun ei voi lisätä osallistujia",
      "errorFailed": "Kutsun lähettäminen epäonnistui"
    },
    "system": {
      "participantAdded": "{{actor}} lisäsi käyttäjän {{target}} keskusteluun",
      "participantRemoved": "{{actor}} poisti käyttäjän {{target}} keskustelusta",
      "participantLeft": "{{actor}} poistui keskustelusta",
      "youAddedParticipant": "Lisäsit käyttäjän {{target}} keskusteluun",
      "youRemovedParticipant": "Poistit käyttäjän {{target}} keskustelusta",
      "youWereAdded": "{{actor}} lisäsi sinut keskusteluun",
      "youWereRemoved": "{{actor}} poisti sinut keskustelusta",
      "inviteSent": "{{actor}} kutsui käyttäjän keskusteluun",
      "youInvited": "Kutsuit käyttäjän keskusteluun",
      "youWereInvited": "{{actor}} kutsui sinut keskusteluun",
      "participantJoined": "Käyttäjä liittyi keskusteluun",
      "youJoined": "Liityit keskusteluun",
      "previewParticipantAdded": "Uusi osallistuja liittyi",
      "previewParticipantLeft": "Osallistuja poistui",
      "previewParticipantRemoved": "Osallistuja poistettiin",
      "previewInviteSent": "Uusi osallistuja kutsuttiin",
      "previewYouJoined": "Liityit keskusteluun",
      "previewYouLeft": "Poistuit keskustelusta",
      "previewYouWereRemoved": "Sinut poistettiin keskustelusta",
      "previewYouInvited": "Kutsuit uuden osallistujan"
    },
    "options": "Asetukset",
    "helpWithSelling": "Apua myyntiin",
    "helpWithBuying": "Apua ostamiseen",
    "helpWithDeal": "Apua kaupankäyntiin",
    "selfSellingGuide": "Itsemyyntiopas",
    "selfSellingGuideUrl": "https://info.jaakko.com/nain-myyt-asunnon-itse",
    "getPersonalHelp": "Apua asiantuntijalta",
    "expertHelp": {
      "title": "Hanki asiantuntija asiakirjojen ja kaupan loppuunsaattamiseen.",
      "pricingBody": "Löysitkö ostajan tai myyjän? Kaipaatko apua kaupan loppuunsaattamiseksi?\n\nYhteistyökumppanimme auttaa kaupan maaliin asti – ilman välityssopimusta tai välityspalkkiota.\n\nHinta: 990 €",
      "subtitle": "Missä tarvitset apua?",
      "topicDocuments": "Taloyhtiön asiakirjat",
      "topicAgreement": "Kaupan loppuun saattaminen",
      "topicNegotiation": "Neuvottelu",
      "topicPricing": "Hinnoittelu",
      "topicViewing": "Näyttöjärjestelyt",
      "topicOther": "Jokin muu",
      "descriptionLabel": "Missä asiassa tarvitset apua?",
      "descriptionPlaceholder": "Kuvaile lyhyesti tilannettasi tai kysymystäsi",
      "contactLabel": "Miten haluat meidän ottavan yhteyttä?",
      "callMe": "Soittamalla",
      "emailMe": "Sähköpostitse",
      "phoneLabel": "Puhelinnumero",
      "emailLabel": "Sähköposti",
      "freeDisclaimer": "Keskustelu ei sido sinua mihinkään ja on maksuton.",
      "continue": "Jatka",
      "sendRequest": "Lähetä pyyntö",
      "successTitle": "Pyyntö lähetetty",
      "successMessage": "Käymme tilanteesi läpi ja otamme yhteyttä puhelimitse tai sähköpostitse.",
      "responseTime": "Tyypillinen vastausaika: 1 arkipäivän kuluessa",
      "backToChat": "Takaisin keskusteluun",
      "systemMessage": "Asiantuntija-apua pyydetty. 🎉 <br/> Olemme sinuun yhteydessä valitsemallasi tavalla puhelimitse tai sähköpostitse. Voit sillä aikaa jatkaa keskustelua normaalisti.<br/>Vastapuoli ei näe tätä viestiä.",
      "limitTitle": "Pyyntöraja saavutettu",
      "limitMessage": "Avoimien asiantuntija-apupyyntöjen enimmäismäärä on saavutettu. Käsittelemme olemassa olevat pyyntösi ensin."
    },
    "firstMessageSuggestions": {
      "header": "Ehdotetut ensiviestit",
      "subheader": "Napauta yht\u00e4 muokataksesi ja l\u00e4hett\u00e4\u00e4ksesi",
      "buyer": {
        "opener": {
          "withAddress": "Hei! T\u00e4m\u00e4 koti her\u00e4tti kiinnostukseni. Voisitko kertoa hieman lis\u00e4\u00e4 asunnosta?",
          "generic": "Hei! T\u00e4m\u00e4 koti her\u00e4tti kiinnostukseni. Voisitko kertoa hieman lis\u00e4\u00e4 asunnosta?",
        },
        "viewing": {
          "withAddress": "Hei! Olen kiinnostunut t\u00e4st\u00e4 kohteesta. Olisiko asuntoa mahdollista päästä katsomaan paikan päälle?",
          "generic": "Hei! Olen kiinnostunut t\u00e4st\u00e4 kohteesta. Olisiko asuntoa mahdollista päästä katsomaan paikan päälle?",
        },
        "financials": {
          "withAddress": "Hei! Olen kiinnostunut kohteesta osoitteessa {{address}}. Voisitko kertoa hieman lis\u00e4\u00e4 taloyhtiöstä?",
          "generic": "Hei! Olen kiinnostunut t\u00e4st\u00e4 kohteesta. Voisitko kertoa hieman lis\u00e4\u00e4 taloyhtiöstä?",
        },
      },
      "seller": {
        "tellMore": {
          "withAddress": "Hei! Kiitos kiinnostuksestasi kotiamme kohtaan. Kerron mielell\u00e4ni lis\u00e4\u00e4 asunnosta.",
          "generic": "Hei! Kiitos kiinnostuksestasi kotiamme kohtaan. Kerron mielell\u00e4ni lis\u00e4\u00e4 asunnosta.",
        },
        "viewing": {
          "withAddress": "Hei! Kiitos kiinnostuksestasi kotiamme kohtaan. Haluaisitko tulla tutustumaan asuntoon paikan päälle?",
          "generic": "Hei! Kiitos kiinnostuksestasi kotiamme kohtaan. Haluaisitko tulla tutustumaan asuntoon paikan päälle?",
        },
        "askMore": {
          "withAddress": "Hei! Kiitos kiinnostuksestasi kotiamme kohtaan osoitteessa {{address}}. Haluaisitko tiet\u00e4\u00e4 jotain tarkemmin asunnosta tai taloyhti\u00f6st\u00e4?",
          "generic": "Hei! Kiitos kiinnostuksestasi kotiamme kohtaan. Haluaisitko tiet\u00e4\u00e4 jotain tarkemmin asunnosta tai taloyhti\u00f6st\u00e4?",
        },
      },
      "aiButton": "Luo AI:n avulla",
      "aiGenerating": "Luodaan\u2026",
      "aiFailed": "Ep\u00e4onnistui \u2014 yrit\u00e4 uudelleen",
    }
  },
  "exploreListings": {
    "allResults": "Kaikki kohteet",
    "exploreButton": "Etsi kohteita",
    "title": "Myynti- ja ostokiinnostukset",
    "titleDesktop": "Myynti- ja ostokiinnostukset",
    "searchPlaceholder": "Hae sijainnilla",
    "filters": "Hakuehdot",
    "listingType": "Ilmoituksen tyyppi",
    "both": "Kaikki",
    "forSale": "Voisin myydä",
    "buyingInterests": "Ostokiinnostukset",
    "buyingInterest": "Ostokiinnostus",
    "propertySize": "Asunnon koko",
    "minSize": "Min",
    "maxSize": "Max",
    "rooms": "Huoneet",
    "any": "Kaikki",
    "floor": "Kerros",
    "minFloor": "Min",
    "maxFloor": "Max",
    "renovationStatus": "Remonttitilanne",
    "anyCondition": "Kaikki kunnot",
    "recentlyRenovated": "Äskettäin remontoitu",
    "goodCondition": "Hyvä kunto",
    "needsRenovation": "Remontin tarpeessa",
    "amenities": "Varustelu",
    "hasElevator": "Hissi",
    "hasBalcony": "Parveke/Terassi",
    "includeIncompleteDetails": "Näytä myös kohteet, joista puuttuu tietoja",
    "includeIncompleteDetailsHelp": "Näytä mahdolliset kohteet, kun valittuja tietoja puuttuu tai niitä ei ole vahvistettu.",
    "unconfirmedCount_one": "{{count}} kohde, jonka tiedoissa on epävarmuutta",
    "unconfirmedCount_other": "{{count}} kohdetta, joiden tiedoissa on epävarmuutta",
    "unconfirmedTitle": "Kohteet, joiden tiedoissa on epävarmuutta",
    "unconfirmedDescription": "Nämä voivat sopia hakuun, mutta kaikkia valittuja tietoja ei voida vahvistaa.",
    "noConfirmedMatches": "Ei vahvistettuja sopivia kohteita",
    "noConfirmedMatchesDescription": "Nämä kohteet voivat silti sopia hakuusi.",
    "unconfirmedField": {
      "seller": {
        "price": "Hinta ei ole vahvistettavissa",
        "size": "Pinta-alaa ei ilmoitettu",
        "rooms": "Huonemäärää ei ilmoitettu",
        "floor": "Kerrosnumeroa ei ilmoitettu",
        "renovationStatus": "Kuntoa ei ilmoitettu",
        "hasElevator": "Hissiä ei vahvistettu",
        "hasBalcony": "Parveketta tai terassia ei vahvistettu"
      },
      "buyer": {
        "size": "Pinta-alatoivetta ei vahvistettu",
        "rooms": "Huonetoivetta ei vahvistettu",
        "floor": "Kerrostavoitetta ei vahvistettu",
        "renovationStatus": "Kuntotoivetta ei vahvistettu",
        "hasElevator": "Hissitoivetta ei vahvistettu",
        "hasBalcony": "Parveke- tai terassitoivetta ei vahvistettu"
      }
    },
    "clearAll": "Tyhjennä",
    "cancel": "Peruuta",
    "showResults": "Näytä tulokset",
    "resultsFound": "kohdetta hakuehdoilla",
    "noResultsTitle": "Ei hakutuloksia",
    "noResultsTitleSecondary": "Ei suoria hakutuloksia",
    "noResultsDescription": "Kokeile muuttaa suodattimia tai hakea eri sijainnista.",
    "endOfResults": "Olet nähnyt kaikki tulokset",
    "loading": "Ladataan...",
    "mapLoadError": "Virhe karttapalveluiden latauksessa",
    "mapLoading": "Ladataan karttapalveluita...",
    "today": "Tänään",
    "yesterday": "Eilen",
    "daysAgo": "{{days}} päivää sitten",
    "roomsShort": "h",
    "floorShort": "Krs",
    "elevator": "Hissi",
    "balcony": "Parveke",
    "contactSeller": "Ota yhteyttä myyjään",
    "contactBuyer": "Ota yhteyttä ostajaan",
    "viewOnMap": "Näytä kartalla",
    "interestedInBuying": "Hei! Olen kiinnostunut ostamaan tästä talosta.",
    "interestedInSelling": "Hei! Olen kiinnostunut myyntikiinnostuksestasi.",
    "openBuildingPage": "Avaa talosivu",
    "mightAlsoContain": "Nämä {{secondaryResultsCount}} ilmoitusta saattavat myös sisältää etsimäsi:"
  },
  "recommendedProperties": {
    "title": "Suosittuja kohteita"
  },
  "listingCard": {
    "new": "Uusi",
    "yourListing": "Oma ilmoituksesi",
    "yourInterest": "Oma kiinnostuksesi",
    "messageSeller": "Kysy myyjältä",
    "couldBuy": "Kysy myyjältä",
    "couldSell": "Voisin myydä",
    "openChat": "Keskusteluun",
    "rooms": "h",
    "floor": "Kerros",
    "balconyTerrace": "Parveke / terassi",
    "recentlyRenovated": "Äskettäin remontoitu",
    "goodCondition": "Hyvä kunto",
    "needsRenovation": "Remontin tarpeessa",
    "like": "Lisää suosikkeihin",
    "share": "Jaa",
    "goToPhoto": "Siirry kuvaan {{index}}",
    "prevPhoto": "Edellinen kuva",
    "nextPhoto": "Seuraava kuva",
    "viewAllPhotos": "Näytä kaikki kuvat",
    "connectForDetails": "Kiinnostunut myyjä – kysy lisää kohteesta",
    "connectBuyerForDetails": "Ostaja etsii kotia – ehdota omaasi.",
    "ownSellerAddDetails": "Lisää tietoja – herätä ostajien kiinnostus.",
    "ownBuyerAddDetails": "Lisää tietoja – herätä myyjien kiinnostus.",
    "noSetPrice": "Ei asetettua hintaa",
    "estimatingPrice": "Arvioidaan hintaa…",
    "estimateInfoAria": "Tietoa Jaakon hinta-arviosta",
    "estimatingInfo": "Jaakko arvioi hintaa tekoälyn ja julkisen markkinadatan avulla. Valmistuva hinta-arvio on suuntaa-antava, ei virallinen arviolausunto.",
    "estimateInfo": "Jaakko on arvioinut hinnan tekoälyn ja markkinatietojen avulla. Kyseessä ei ole myyjän asettama pyyntihinta eikä virallinen arviolausunto, vaan suuntaa-antava keskustelunavaus – voit neuvotella hinnasta suoraan myyjän kanssa."
  },
  "listingView": {
    "viewBuilding": "Siirry talosivulle",
    "viewOnMap": "Näytä kartalla",
    "notFound": "Ilmoitusta ei löytynyt",
    "otherListings": "Muut ilmoitukset tässä rakennuksessa",
    "sellersHere": "Myyjät täällä",
    "buyersHere": "Ostajat täällä",
    "otherSellersHere": "Muut myyjät täällä",
    "otherBuyersHere": "Muut ostajat täällä",
    "explore": "Selaa Jaakkoa",
    "interestedPrompt": "Kiinnostuitko? Lähetä viesti myyjälle.",
    "openChatPrompt": "Sinulla on jo keskustelu myyjän kanssa.",
    "buyerPrompt": "Omistatko kodin, jollaista tämä ostaja etsii? Kerro siitä hänelle.",
    "sellerBadge": "Myyjä",
    "buyerBadge": "Ostaja"
  },
  "priceEstimation": {
    "title": "Asunnon hinta-arvioraportti",
    "notAvailable": "Ei saatavilla",
    "estimatedValue": "Arvioitu Markkina-arvo",
    "priceRange": "Hintahaarukka",
    "pricePerSqm": "Hinta per m²",
    "confidence": "Luottamus",
    "propertyDetails": "Lisätiedot",
    "size": "Koko",
    "rooms": "Huoneet",
    "floor": "Kerros",
    "elevator": "Hissi",
    "balcony": "Parveke",
    "condition": "Kunto",
    "buildingType": "Rakennustyyppi",
    "fullAnalysis": "Täydellinen Markkina-analyysi",
    "marketFactors": "Keskeiset Markkinatekijät",
    "comparableProperties": "Vertailukelpoiset Asunnot",
    "recommendations": "Arvon Optimointisuositukset",
    "sources": "Tietolähteet",
    "disclaimer": "Tämä arvio perustuu tekoälyn analysoimaan markkinadataan ja sitä tulee käyttää vain ohjeellisena arviona. Todellinen markkina-arvo voi vaihdella.",
    "generatedOn": "Luotu",
    "print": "Tulosta",
    "share": "Jaa",
    "close": "Sulje",
    "shareTitle": "Asunnon hinta-arvio",
    "shareText": "Katso asunnon hinta-arvio osoitteesta",
    "linkCopied": "Linkki kopioitu leikepöydälle",
    "or": "tai",
    "exploreJaakko": "Selaa Jaakkoa"
  },
  "priceEstimations": {
    "pageTitle": "Hinta-arviot",
    "loading": "Ladataan arvioita...",
    "allStatuses": "Kaikki tilat",
    "statusQueued": "Jonossa",
    "statusInProgress": "Arvioidaan",
    "statusCompleted": "Valmis",
    "statusFailed": "Epäonnistui",
    "statusTimedOut": "Aikakatkaistiin",
    "noEstimations": "Ei vielä hinta-arvioita",
    "noEstimationsDesc": "Hinta-arviosi tulevat tänne näkyviin, kun pyydät niitä.",
    "unknownAddress": "Tuntematon osoite",
    "created": "Luotu",
    "completed": "Valmistunut",
    "viewReport": "Näytä raportti",
    "errorLoadingReport": "Raportin lataus epäonnistui. Yritä uudelleen.",
    "failedMessage": "Hinta-arvio epäonnistui. Yritä uudelleen.",
    "timedOutMessage": "Hinta-arvion aikakatkaisu. Yritä uudelleen.",
    "pageInfo": "Sivu",
    "loadMore": "Lataa lisää",
    "rooms": "huonetta",
    "confidence": "luottamus"
  },
  "feedback": {
    "title": "Lähetä palautetta",
    "intro": "Haluamme kuulla mielipiteesi! Palautteesi auttaa meitä kehittämään Jaakkoa.",
    "type": {
      "label": "Palautteen tyyppi",
      "general": "Yleinen palaute",
      "bug": "Virheilmoitus",
      "feature": "Uusi toiminnallisuus -pyyntö",
      "improvement": "Parannusehdotus"
    },
    "email": {
      "label": "Sähköpostiosoitteesi",
      "placeholder": "sahkoposti@esimerkki.com",
      "help": "Vastaamme sähköpostiisi."
    },
    "subject": {
      "label": "Aihe",
      "placeholder": "Aihe"
    },
    "message": {
      "label": "Palautteesi",
      "placeholder": "Kerro ajatuksistasi, ehdotuksistasi tai raportoi kohtaamistasi ongelmista..."
    },
    "submit": "Lähetä palaute",
    "submitting": "Lähetetään...",
    "success": "Kiitos palautteestasi! Vastaamme sinulle pian sähköpostitse.",
    "validation": {
      "messageRequired": "Kirjoita palauteviestisi.",
      "emailRequired": "Anna sähköpostiosoitteesi.",
      "emailInvalid": "Anna kelvollinen sähköpostiosoite."
    },
    "error": {
      "submitFailed": "Palautteen lähetys epäonnistui. Yritä uudelleen."
    }
  },
  "tipBuyer": {
    "button": "Ehdota",
    "menuTitle": "Ehdota ostajalle kotiasi",
    "emptyState": "Sinulla ei ole myynnissä olevia kohteita",
    "confirmTitle": "Vinkkaa ostajalle tästä kohteesta?",
    "confirmDescription": "Ostaja saa Jaakolta viestin kohteestasi.",
    "messagePreview": "Myyjä vinkkasi sinulle hänen kohteesta:",
    "receivedMessage": "Ostokiinnostuksesi perusteella myyjä vinkkasi sinulle tästä kohteesta:",
    "sendTip": "Lähetä vinkki",
    "success": "Vinkki lähetetty!",
    "successTitle": "Vinkki lähetetty!",
    "successSubtitle": "Ostaja saa ilmoituksen kohteestasi",
    "alreadyTipped": "Olet jo vinkannut tälle ostajalle tästä kohteesta",
    "sent": "Lähetetty",
    "dailyLimitReached": "Olet käyttänyt päivän vinkkisi. Yritä huomenna uudelleen!",
    "conversationPreview": "🏠 Myyjä vinkkasi sinulle kohteesta",
    "loginPrompt": "Kirjaudu sisään ehdottaaksesi kotiasi ostajalle"
  },
  "profile": {
    "title": "Profiili",
    "sellListings": "Omat kohteet",
    "buyInterests": "Osto\u00ADkiinnostukseni",
    "priceEstimations": "Hinta-arviot",
    "accountSettings": "Tiliasetukset",
    "logOut": "Kirjaudu ulos",
    "phoneNumber": "Puhelinnumero",
    "edit": "Muokkaa",
    "add": "Lisää",
    "cancel": "Peruuta",
    "save": "Tallenna",
    "addPhoneNumber": "Lisää puhelinnumero saadaksesi tekstiviestin, kun ostaja tai myyjä kiinnostuu ilmoituksestasi, käyttäjä lähettää sinulle yksityisviestin, tai tilaamasi hinta-arvio valmistuu. Huom. Emme anna numeroa muille käyttäjille ja viestit ovat sinulle maksuttomia.",
    "phonePlaceholder": "40 123 4567",
    "sendCode": "Lähetä vahvistuskoodi",
    "verifyCode": "Syötä vahvistuskoodi",
    "verifyCodePlaceholder": "6-numeroinen koodi",
    "verify": "Vahvista",
    "resendCode": "Lähetä koodi uudelleen",
    "codeSent": "Vahvistuskoodi lähetetty numeroon {{phone}}",
    "codeResent": "Uusi koodi lähetetty",
    "phoneVerified": "Puhelinnumero vahvistettu",
    "removeNumber": "Poista numero",
    "removeNumberConfirm": "Haluatko varmasti poistaa puhelinnumerosi? Tekstiviesti-ilmoitukset poistetaan käytöstä.",
    "smsNotifications": "Tekstiviesti-ilmoitukset",
    "smsNotificationsDescription": "Saat tekstiviesti-ilmoituksen, kun ostajat tai myyjät kiinnostuvat kohteestasi, saat uuden suoraviestin tai hinta-arviosi valmistuu.",
    "invalidPhone": "Anna kelvollinen suomalainen puhelinnumero (esim. +358401234567).",
    "phoneAlreadyInUse": "Tämä puhelinnumero on jo toisen tilin käytössä.",
    "rateLimitExceeded": "Liian monta yritystä. Yritä myöhemmin uudelleen.",
    "smsSendFailed": "Tekstiviestin lähetys epäonnistui. Yritä myöhemmin uudelleen.",
    "invalidCode": "Virheellinen vahvistuskoodi.",
    "codeExpired": "Vahvistuskoodi on vanhentunut. Pyydä uusi koodi.",
    "genericError": "Jokin meni pieleen. Yritä uudelleen.",
    "phoneAlreadyVerifiedHint": "Tämä numero on jo vahvistettu. Vaihda numeroa lähettääksesi uuden koodin.",
    "phoneAlreadyVerified": "Tämä puhelinnumero on jo vahvistettu.",
    "noSellListings": "Ei kohteita.",
    "noBuyListings": "Ei ostokiinnostuksia.",
    "mySellListings": "Omat kohteet",
    "myBuyInterests": "Ostokiinnostukseni",
    "notificationSettings": "Ilmoitusasetukset"
  },
  "notificationSettings": {
    "pageTitle": "Ilmoitusasetukset",
    "tableDescription": "Valitse, mitä ilmoituksia haluat vastaanottaa tekstiviestillä tai sähköpostilla.",
    "smsColumn": "SMS",
    "emailColumn": "Sähköposti",
    "match": "Osuma (ostaja/myyjä löytyi)",
    "message": "Uusi viesti toiselta käyttäjältä",
    "priceEstimation": "Hinta-arvio valmis",
    "propertyTip": "Asuntovinkki",
    "marketingConsent": "Markkinointiviestit",
    "marketingSection": "Markkinointi",
    "saved": "Asetukset tallennettu",
    "errorSaving": "Asetusten tallennus epäonnistui. Yritä uudelleen.",
    "phoneRequiredHint": "Lisää ja vahvista puhelinnumerosi ottaaksesi tekstiviesti-ilmoitukset käyttöön."
  },
  "marketingConsentModal": {
    "headerTitle": "Pysy ajan tasalla",
    "headline": "Haluan vinkkejä ja päivityksiä Jaakolta",
    "benefits": {
      "first": "Uusia kohteita, hintatietoja ja Jaakon päivitykset",
      "second": "Vinkit asunnon ostoon ja myyntiin ilman välittäjää",
      "third": "Satunnaisia tarjouksia, ei roskapostia"
    },
    "decline": "Ei nyt",
    "accept": "Kyllä, lähetä",
    "subtext": "Voit peruuttaa milloin tahansa."
  },
  "verification": {
    "verifiedPerson": "Tunnistettu henkilö",
    "verifiedSeller": "Tunnistettu myyjä",
    "verifiedBuyer": "Tunnistettu ostaja",
    "verifyIdentity": "Vahvista henkilöllisyys",
    "inProgress": "Vahvistus käynnissä",
    "incompleteTryAgain": "Vahvistus jäi kesken. Yritä uudelleen."
  }
};
